import { currencySign } from '../../currencySign';

const stringSeparateur = (string) => {
  const arr = string.split(/[,:]+/);
  return arr;
};

const generateInfo = (data) => {
  const infos = {};
  data.forEach((i, k) => {
    const afterTrim = i.trim();
    if (k % 2 === 0) {
      switch (afterTrim) {
        case 'labelKm':
          infos[afterTrim] = `${data[k + 1]} km`;
          break;
        case 'labelOffre':
          infos[afterTrim] = currencySign(data[k + 1]);
          break;
        default:
          infos[afterTrim] = data[k + 1];
          break;
      }
    }
  });
  return infos;
};

export const historyPresenter = (history) => {
  const formatBody = [...history];
  if (formatBody.length > 0) {
    formatBody.forEach((res, key) => {
      if (typeof res.body !== 'object') {
        const data = stringSeparateur(res.body);
        if (data) formatBody[key].body = generateInfo(data);
      }
    });
  }
  return formatBody.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
};
